/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-03-01T09:24:34-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-08-11T14:25:38-07:00
*/



import React, { Component } from 'react';
import Button from '../../blocks/Button';
import TextInput from '../../common/TextInput';
import InputGroup from '../../blocks/InputGroup';
import Header from '../../blocks/Header';
import Headline from '../../common/Headline';
import Container from '../../blocks/Container';

import _ from 'lodash';

class ChangePassword extends Component {

  constructor(props) {
    super(props);
    this.state = {
      old_password: '',
      password: '',
      password_confirm: ''
    }
    this.updatePasswordFormHandler = this.updatePasswordFormHandler.bind(this);
    this.setOldPassword = this.setOldPassword.bind(this);
    this.setPassword = this.setPassword.bind(this);
    this.setPasswordConfirm = this.setPasswordConfirm.bind(this);
  }

  setOldPassword(e) {
    this.setState({old_password: e.target.value});
  }
  setPassword(e) {
    this.setState({password: e.target.value});
  }
  setPasswordConfirm(e) {
    this.setState({password_confirm: e.target.value});
  }

  updatePasswordFormHandler(e) {
    e.preventDefault();
    this.props.updatePasswordForm(this.state, () => {
      this.setState({old_password: '', password: '', password_confirm: ''});
    });

  }

  render() {

    let enabledSubmit = Boolean(this.state.old_password) && Boolean(this.state.password) && Boolean(this.state.password_confirm);
    var { error_password } = this.props.errors;
    if(_.isNil(error_password)) var error_password = {};

    return (
      <div>

        {/* PASSWORD */}
              <div className="panel">
                <Header>
                  <div>
                    <Headline>Change your password</Headline>
                  </div>
                </Header>
                <Container spacedBottom>
                  <form id="change_password" onSubmit={this.updatePasswordFormHandler}>
                    {/* Current PW  */}
                    <InputGroup vertical inputLabel="Current Password" errors={error_password.old_password}>
                      <TextInput type="password" value={this.state.old_password} error={error_password.old_password} onChange={this.setOldPassword} />
                    </InputGroup>
                    {/* New PW  */}
                    <InputGroup vertical inputLabel="New Password" errors={error_password.password}>
                      <TextInput type="password" value={this.state.password} error={error_password.password} onChange={this.setPassword} />
                    </InputGroup>
                    {/* Conf New PW  */}
                    <InputGroup vertical inputLabel="Confirm New Password" errors={error_password.password_confirm}>
                      <TextInput type="password" value={this.state.password_confirm} error={error_password.password_confirm} onChange={this.setPasswordConfirm} />
                    </InputGroup>
                    {/* Submit Password  */}
                    <div className="SplitInfo">
                      <div className="SplitInfo__Title right">
                      </div>
                      <div className="buttonSet">
                        <Button disabled={!enabledSubmit} variant="simple" type="submit" name="commit">Change Password</Button>
                      </div>
                    </div>
                  </form>
                </Container>
              </div>



      </div>
    );
  }
}

export default ChangePassword;



// WEBPACK FOOTER //
// ./src/components/pages/Settings/ChangePassword.jsx